import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
// import Cookies from 'js-cookie'
// let language = Cookies.get('storeLanguage');
import { monthNames, weekDayNames, monthNamesJpa, weekDayNamesJpa } from './config.js';
export default {
  name: "cal-month",
  props: {
    month: {
      type: Number,
      default: 0
    },
    year: {
      type: Number,
      default: 0
    },
    holiday: {
      type: Array,
      default: []
    },
    checked: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      monthList: [],
      weekList: []
    };
  },
  computed: {},
  mounted: function mounted() {
    this.monthList = monthNamesJpa;
    this.weekList = weekDayNamesJpa;
  },
  watch: {},
  methods: {
    testaclick: function testaclick(evt) {
      evt.preventDefault();
      var date = evt.target;
      // console.log(evt.target.dataset.date);
      this.$emit('changeDay', evt.target.dataset);
      // console.log(this.holiday);
    },
    datejudge: function datejudge(data) {
      var status = 3;
      for (var i in this.holiday) {
        //如果里面有这个值返回 1
        // console.log(data+","+ this.holiday[i].holidayDate + ","+i);
        if (this.holiday[i].holidayDate == data) {
          //0是休息  1是工作
          if (this.holiday[i].holidayState == 1) {
            status = 1;
            break;
          } else if (this.holiday[i].holidayState == 0) {
            status = 2;
            break;
          }
        } else {
          status = 3;
        }
      }
      return status;
    }
  },
  render: function render(createElement) {
    // console.log(this.holiday);
    var is_today = 0;
    var children = [];
    var today = new Date();
    var startDate = new Date(this.year, this.month, 1); // primeiro dia do mês
    var endOfMonth = new Date(this.year, this.month + 1, 0); // fim do mês
    var endOfPreviousMonth = new Date(this.year, this.month, 0); // fim do mês anterior
    // console.log(typeof(this.holiday))

    // gerar a linha de headr com o nome do mês
    children.push(createElement("span", {
      class: "day grow"
    }, this.monthList[this.month]));
    // Gerar linha de header com os nomes dos dias da semana
    var _iterator = _createForOfIteratorHelper(this.weekList),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var weekDay = _step.value;
        children.push(createElement("span", {
          class: "day header"
        }, weekDay));
      }
      // Padding até ao dia da semana correspondente ao início do mês actual
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    for (var j = 1; j <= endOfPreviousMonth.getDay(); j++) {
      children.push(createElement("span", {
        class: "day"
      }, ""));
    }
    for (var dayNumber = 1; dayNumber <= endOfMonth.getDate(); dayNumber++) {
      is_today = 0;
      var classes = ['day'];
      var day = new Date(this.year, this.month, dayNumber);
      if (day.getDay() === 0 || day.getDay() === 6) {
        classes.push('weekend');
      }
      // console.log(day.toLocaleDateString()) //这个是获取12月内所有的日期
      // 				if (this.holiday.length == 0) {
      // 					if ((day.getDay() == 6 || day.getDay() == 0) && this.checked) {
      // 						classes.push('today');
      // 						is_today = 1;
      // 					}
      // 				} else {
      // 					
      // 				}
      // console.log("aaaa"+this.checked)
      if (this.datejudge(day.toLocaleDateString()) == 2) {
        classes.push('today');
        is_today = 1;
      } else if (this.datejudge(day.toLocaleDateString()) == 1) {} else if ((day.getDay() == 6 || day.getDay() == 0) && this.checked) {
        classes.push('today');
        is_today = 1;
      }
      // 
      // validar se é uma data no passado
      if (day < today) {
        classes.push('past');
      }
      // console.log(dayNumber);
      children.push(createElement("a", {
        attrs: {
          href: "#",
          "data-date": this.year + "/" + (this.month + 1) + "/" + dayNumber,
          "data-is_today": is_today
        },
        class: classes.join(' '),
        on: {
          click: this.testaclick
        }
      }, dayNumber < 10 ? '0' + dayNumber : dayNumber // dayNumber < 10 ? `0${dayNumber}` : dayNumber
      ));
    }
    // Padding para fazer o próximo mês começar na linha seguinte
    for (var k = endOfMonth.getDay() + 1; k <= 7; k++) {
      children.push(createElement("span", {
        class: "day"
      }, ""));
    }
    return createElement("div",
    // tag name
    {
      class: "month"
    }, children // array of children
    );
  }
};